import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createSubQualityItem,
  getAllSubQualityItems,
  getDataForEdit,
  updateSubQualityItem,
  deleteSubQualityItem,
} from "../../store/SubQuality/SubQualityApi";
import { getAllQualityItems } from "../../store/AppLevelApi/AppLevelApi";

import { subQualitySliceAction } from "../../store/SubQuality/SubQualitySlice";

import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsSubQuality } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialSubQualityFormData } from "../../ConstantData/InitialData";
//imporint form data error
import { ErrorSubQualityFormData } from "../../ConstantData/ErrorOption";
function SubQuality() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllQualityItems());
    // dispatch(getAllSubQualityItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const subQualityList = useSelector(
    (state) => state.subquality.subQualityList
  );
  const InitialFormDataStore = useSelector(
    (state) => state.subquality.initialData
  );
  const subQualityEditData = useSelector((state) => state.subquality.dataEdit);
  let isError = useSelector((state) => state.quality.isError);
  let subQualityFormError = useSelector((state) => state.subquality.errorData);
  subQualityFormError = { ...ErrorSubQualityFormData, ...subQualityFormError };
  const qualityList = useSelector((state) => state.applevel.qualityList);

  let newFormOptionsSubQuality = JSON.parse(
    JSON.stringify(FormOptionsSubQuality)
  );

  if (qualityList.length > 0) {
    //to chage subquality option coming from server
    newFormOptionsSubQuality = FormOptionsSubQuality.map((item) => {
      if (item?.labelName === "Quality") {
        item.options = qualityList;
      }
      return item;
    });
  }

  const headTitleLabel = headTitle(FormOptionsSubQuality, ["Name", "Quality"]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialSubQualityFormData}
      //function coming from store
      getDataForEdit={getDataForEdit}
      delteFun={deleteSubQualityItem}
      createFun={createSubQualityItem} //create function coming from store
      updateFun={updateSubQualityItem} //update function coming from store
      FormOptions={newFormOptionsSubQuality}
      OptionName="Create Sub Quality"
      OptionNameList="SubQuality"
      generalList={subQualityList}
      headTitle={headTitleLabel}
      isError={isError}
      ErrorData={subQualityFormError}
      setErrorData={subQualitySliceAction.setErrorData}
      EditData={subQualityEditData}
      InitialFormDataStore={InitialFormDataStore}
      generalModuleList={qualityList} //list to add different module
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default SubQuality;
